export interface QuizOption {
  text: string
  tag: string
}

export interface QuizQuestion {
  id: number
  question: string
  options: QuizOption[]
}

export interface ResultProfile {
  id: 'A' | 'B' | 'C' | 'D'
  emoji: string
  title: string
  subtitle: string
  diagnosis: string
  steps: string[]
  cta: string
}

export const quizQuestions: QuizQuestion[] = [
  {
    id: 1,
    question: '¿Cuál es tu situación actual con ingresos online?',
    options: [
      { text: 'Cero, estoy empezando', tag: 'START_0' },
      { text: 'Ya he ganado algo, pero es irregular', tag: 'START_IRREG' },
      { text: 'Tengo ingresos, pero quiero escalar', tag: 'START_SCALE' },
      {
        text: 'Tengo un negocio y quiero automatizar con IA',
        tag: 'START_BIZ',
      },
    ],
  },
  {
    id: 2,
    question: '¿Cuánto tiempo REAL puedes dedicar en los próximos 7 días?',
    options: [
      { text: '30–60 min/día', tag: 'TIME_LOW' },
      { text: '1–2 horas/día', tag: 'TIME_MED' },
      { text: '2–4 horas/día', tag: 'TIME_HIGH' },
      { text: '4+ horas/día', tag: 'TIME_MAX' },
    ],
  },
  {
    id: 3,
    question: '¿Qué te frena más ahora mismo?',
    options: [
      { text: 'No sé qué vender', tag: 'BLOCK_OFFER' },
      { text: 'No sé cómo conseguir clientes', tag: 'BLOCK_TRAFFIC' },
      { text: 'Me disperso y no ejecuto', tag: 'BLOCK_FOCUS' },
      { text: 'Me falta confianza/claridad', tag: 'BLOCK_CONF' },
      { text: 'No tengo sistema, hago de todo', tag: 'BLOCK_SYSTEM' },
    ],
  },
  {
    id: 4,
    question: '¿Cuál de estas habilidades es tu "punto fuerte" hoy?',
    options: [
      { text: 'Hablar/vender (DM, llamadas)', tag: 'SKILL_SALES' },
      { text: 'Crear contenido (Reels, TikTok, posts)', tag: 'SKILL_CONTENT' },
      { text: 'Operaciones/organización', tag: 'SKILL_OPS' },
      { text: 'Diseño/copy/creatividad', tag: 'SKILL_CREATIVE' },
      { text: 'Tech / herramientas / automatización', tag: 'SKILL_TECH' },
    ],
  },
  {
    id: 5,
    question: '¿Qué tipo de modelo te atrae más (aunque no sepas hacerlo aún)?',
    options: [
      { text: 'Servicios con IA (rápido por ticket)', tag: 'MODEL_SERVICE' },
      { text: 'Agencia/retainer mensual', tag: 'MODEL_AGENCY' },
      { text: 'Afiliados/ventas sin producto propio', tag: 'MODEL_AFFIL' },
      { text: 'Producto digital low ticket', tag: 'MODEL_DIGITAL' },
      { text: 'Automatizaciones para negocios', tag: 'MODEL_AUTOMATION' },
    ],
  },
  {
    id: 6,
    question: '¿Cuál es tu mayor miedo con la IA?',
    options: [
      { text: '"No soy técnico"', tag: 'FEAR_TECH' },
      { text: '"Ya está saturado"', tag: 'FEAR_SAT' },
      { text: '"Me van a estafar / no es real"', tag: 'FEAR_SCAM' },
      { text: '"No sé por dónde empezar"', tag: 'FEAR_START' },
      { text: '"No voy a ser constante"', tag: 'FEAR_CONSIST' },
    ],
  },
  {
    id: 7,
    question: 'Si tuvieras que elegir un resultado en 48H, ¿cuál sería?',
    options: [
      { text: 'Tener una oferta lista para vender', tag: 'GOAL_OFFER' },
      { text: 'Conseguir mis primeros leads (mensajes)', tag: 'GOAL_LEADS' },
      { text: 'Cerrar 1–3 ventas', tag: 'GOAL_SALES' },
      { text: 'Montar un sistema/automatización base', tag: 'GOAL_SYSTEM' },
      { text: 'Crear contenido que convierta', tag: 'GOAL_CONTENT' },
    ],
  },
  {
    id: 8,
    question: '¿Dónde te sientes más cómodo vendiendo?',
    options: [
      { text: 'Mensajes (DM/WhatsApp)', tag: 'SELL_DM' },
      { text: 'Llamadas (Zoom/Phone)', tag: 'SELL_CALL' },
      { text: 'Página / checkout (sin hablar)', tag: 'SELL_SILENT' },
      { text: 'Aún no vendo', tag: 'SELL_NONE' },
    ],
  },
  {
    id: 9,
    question: '¿Cuál es tu audiencia más probable ahora?',
    options: [
      { text: 'Emprendedores/negocios', tag: 'AUD_BIZ' },
      { text: 'Fitness/estética/bienestar', tag: 'AUD_WELLNESS' },
      { text: 'Educación/idiomas/coaching', tag: 'AUD_COACH' },
      { text: 'Ecommerce/tiendas', tag: 'AUD_ECOM' },
      { text: 'No tengo audiencia', tag: 'AUD_NONE' },
    ],
  },
  {
    id: 10,
    question: '¿Qué describe mejor tu situación con el contenido?',
    options: [
      { text: 'No publico', tag: 'CONT_NONE' },
      { text: 'Publico pero sin estrategia', tag: 'CONT_RANDOM' },
      { text: 'Publico constante pero no vendo', tag: 'CONT_NOSELL' },
      { text: 'Ya vendo con contenido', tag: 'CONT_SELL' },
    ],
  },
  {
    id: 11,
    question: '¿Cuál es tu principal estilo de trabajo?',
    options: [
      { text: 'Necesito un plan exacto (checklist)', tag: 'STYLE_STRUCTURE' },
      { text: 'Me motivo por retos/corto plazo', tag: 'STYLE_CHALLENGE' },
      { text: 'Aprendo probando rápido', tag: 'STYLE_TESTER' },
      { text: 'Me bloqueo si no es perfecto', tag: 'STYLE_PERF' },
    ],
  },
  {
    id: 12,
    question: 'Elige tu "compromiso real" para las próximas 48H:',
    options: [
      { text: 'Haré lo mínimo viable (1 acción clave)', tag: 'COMMIT_MIN' },
      { text: 'Haré el plan completo (2–3 bloques)', tag: 'COMMIT_FULL' },
      { text: 'Voy con todo (ejecución intensiva)', tag: 'COMMIT_MAX' },
    ],
  },
]

export const resultProfiles: ResultProfile[] = [
  {
    id: 'A',
    emoji: '🎯',
    title: 'Cerrador Express',
    subtitle: 'Servicios con IA',
    diagnosis:
      'No necesitas más ideas. Necesitas una oferta simple + mensajes que conviertan. Tu perfil es de acción directa: vendes hablando, y la IA te da velocidad.',
    steps: [
      'Elegir 1 servicio rápido con IA (deliverable en 24h)',
      'Montar 1 oferta irresistible + garantía simple',
      'Outreach/DM script + 20 contactos',
      'Cierre con guion (DM o llamada)',
    ],
    cta: 'Tu plan completo está dentro de "48H AI Cash Machine".',
  },
  {
    id: 'B',
    emoji: '⚙️',
    title: 'Automatizador de Negocios',
    subtitle: 'AI Systems',
    diagnosis:
      'Tu dinero está en ahorrar tiempo + mejorar conversiones a otros negocios con automatización. Tienes la mentalidad de sistemas y la IA es tu palanca.',
    steps: [
      'Elegir 1 automatización vendible (lead capture, seguimiento, agenda)',
      'Plantilla + implementación rápida',
      'Caso demo + propuesta simple',
      'Cerrar 1 cliente piloto',
    ],
    cta: 'Accede al blueprint exacto en 48H AI Cash Machine.',
  },
  {
    id: 'C',
    emoji: '🎬',
    title: 'Creador que Convierte',
    subtitle: 'Contenido + IA',
    diagnosis:
      'Publicar no es el problema: falta estructura de contenido que lleve a DM/ventas. Tienes la creatividad, solo necesitas el sistema.',
    steps: [
      '3 ángulos de contenido + ganchos con IA',
      '5 guiones cortos (Reels/TikTok)',
      'CTA a DM + respuesta automática',
      'Oferta simple para cerrar',
    ],
    cta: 'Tu sistema está listo para implementarse en 48H AI Cash Machine.',
  },
  {
    id: 'D',
    emoji: '📦',
    title: 'Producto Rápido',
    subtitle: 'Low Ticket + IA',
    diagnosis:
      'Tu mejor ruta es crear un producto simple, venderlo con una página y automatizar. No necesitas hablar con nadie: la IA crea, la página vende.',
    steps: [
      'Idea validable + promesa clara',
      'Producto mínimo (plantilla/guía) creado con IA',
      'Página simple + checkout',
      'Tráfico inicial (contenido o afiliados)',
    ],
    cta: 'Dentro de 48H AI Cash Machine tienes la estructura exacta.',
  },
]

export function calculateResult(tags: string[]): ResultProfile {
  const has = (t: string) => tags.includes(t)
  const hasAny = (...ts: string[]) => ts.some((t) => tags.includes(t))

  // Score each profile
  let scores = { A: 0, B: 0, C: 0, D: 0 }

  // Rule 1: SKILL_SALES or SELL_DM/CALL → A
  if (has('SKILL_SALES')) scores.A += 3
  if (has('SELL_DM')) scores.A += 2
  if (has('SELL_CALL')) scores.A += 2
  if (has('MODEL_SERVICE')) scores.A += 1
  if (has('GOAL_SALES')) scores.A += 2
  if (has('GOAL_LEADS')) scores.A += 1

  // Rule 2: START_BIZ + SKILL_TECH/OPS → B
  if (has('START_BIZ')) scores.B += 2
  if (has('SKILL_TECH')) scores.B += 3
  if (has('SKILL_OPS')) scores.B += 2
  if (has('MODEL_AUTOMATION')) scores.B += 2
  if (has('GOAL_SYSTEM')) scores.B += 2

  // Rule 3: SKILL_CONTENT/CREATIVE → C
  if (has('SKILL_CONTENT')) scores.C += 3
  if (has('SKILL_CREATIVE')) scores.C += 2
  if (hasAny('CONT_RANDOM', 'CONT_NOSELL')) scores.C += 2
  if (has('GOAL_CONTENT')) scores.C += 2
  if (has('GOAL_LEADS')) scores.C += 1

  // Rule 4: SELL_SILENT + MODEL_DIGITAL → D
  if (has('SELL_SILENT')) scores.D += 3
  if (has('MODEL_DIGITAL')) scores.D += 3
  if (has('GOAL_OFFER')) scores.D += 2
  if (has('MODEL_AFFIL')) scores.D += 1

  // Tiebreaker by GOAL
  if (has('GOAL_SALES')) scores.A += 1
  if (has('GOAL_SYSTEM')) scores.B += 1
  if (has('GOAL_CONTENT')) scores.C += 1
  if (has('GOAL_OFFER')) scores.D += 1

  const sorted = Object.entries(scores).sort(([, a], [, b]) => b - a)
  const winnerId = sorted[0][0] as 'A' | 'B' | 'C' | 'D'

  return resultProfiles.find((p) => p.id === winnerId) || resultProfiles[0]
}
